export var tealiumList = {
  HHY1: true,
  HHY2: true
};